import { Component, Input, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import * as _ from 'lodash';
import { AddressItems } from 'src/app/shared/components/address-fields/models/address-Items.model';
import { emptyAddress } from 'src/app/shared/enum/empty-address';
import { addressElements } from 'src/app/shared/enum/address-elements';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModalComponent, ModalModel } from 'src/app/shared/components/modal/modal.component';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';

@Component({
    selector: 'address-comp',
    templateUrl: './address-comp.component.html',
    styleUrls: ['./address-comp.component.scss'],
    standalone: false
})

export class AddressCompComponent implements OnInit,OnDestroy {
  recieved : any;
  data : [];
  protected onDestroy = new Subject<void>();
  subscriptions: Subscription[] = [];
  @Input('customerAddressArr') customerAddressArr: any;
  @Input('tempIndex') tempIndex: any;
  set dataSet(customerAddressArr : any) {
    // this.recieved = [...this.recieved, 'Setter got a value'];
    this.customerAddressArr = customerAddressArr;
  }
  @Input() customerAddressStyle: any;
  @Input() isDisabled: boolean = false;
  @Input() needOtherFields: boolean = false;
  @Input() field_address: any;
  @Input() addressRequired: boolean = false;
  @Input() showAddressError: boolean = false;
  @Input() isEquoteModule;

  selectedAddress: string = '';
  addressFormate: any;
  addressFormateArrView = [];
  public fg: FormGroup;
  public addressItems: AddressItems;
  public lineItems: FormArray
  constructor(private _fb: FormBuilder, public dialog: MatDialog,private snackBar: MatSnackBar,private translateService: TranslateService,) { }



  ngOnInit(): void {
    if (this.field_address?.type?.length > 0) {
      if(this.field_address?.type?.length ==1){
        this.selectedAddress = this.field_address.type[0];

      }else{
        const matchedAddress = this.customerAddressArr?.find(addr => 
          addr?.city?.trim() || addr?.country?.trim() || addr?.house_number?.trim() ||
          addr?.interior_number?.trim() || addr?.postal_code?.trim() ||
          addr?.state?.trim() || addr?.street_name?.trim()
        );
        if (matchedAddress) {
          this.selectedAddress = matchedAddress?.title;
        }
      }
    }   

     if (this.tempIndex == undefined) {
      this.tempIndex = 0;
    } else {
      this.tempIndex = Number(this.tempIndex) + 1
    }
    this.addressItems = new AddressItems(this.customerAddressArr);
    this.fg = this._fb.group(this.addressItems.validationRules());
    if (this.customerAddressArr?.length) {
      _.each(this.customerAddressArr, (o) => { this.addLineItem(this.customerAddressArr.indexOf(o)); });
    } else { this.addLineItem(0); }

    this.getAddressOrder();
    setTimeout(() => {
      this.fg.patchValue(this.addressItems);
      if (this.customerAddressArr.length < 1) {
        this.customerAddressArr.push(new emptyAddress());
      }
    }, 2000);
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.onDestroy.next(null);
    this.onDestroy.complete();
    this.subscriptions.forEach(s => s.unsubscribe());

    // prevent memory leak when component destroyed
  }

  async getAddressOrder() {
    let addressFormatSequance = localStorage.getItem('address_format');
    if (addressFormatSequance) {
      this.addressFormate = addressFormatSequance.split(',');
      this.addressFormate.forEach((format, index) => {
        this.addressFormateArrView.push(format);
      })
    }
    if (this.addressFormateArrView.length <= 0) {
      this.addressFormateArrView = addressElements;
    }
  }
  hideDiv: boolean = false;  // Set it to true to hide the div

  // Function or logic to determine when to hide the div
  toggleDivVisibility() {
    this.hideDiv = !this.hideDiv;
  }

  public addLineItem(index): void {
    this.lineItems = this.fg.get('lineItems') as FormArray;
    const lineItem = this._fb.group(this.addressItems.lineItemValidationRules());
    lineItem.get('formattedAddress').valueChanges.subscribe((value) => { this.customerAddressArr[index].formattedAddress = value });
    lineItem.get('city').valueChanges.subscribe((value) => { this.customerAddressArr[index].city = value; this.recomputeAddressError(); });
    lineItem.get('country').valueChanges.subscribe((value) => { this.customerAddressArr[index].country = value; this.recomputeAddressError(); });
    lineItem.get('state').valueChanges.subscribe((value) => { this.customerAddressArr[index].state = value; this.recomputeAddressError(); });
    lineItem.get('postal_code').valueChanges.subscribe((value) => { this.customerAddressArr[index].postal_code = value; this.recomputeAddressError(); });
    lineItem.get('street_name').valueChanges.subscribe((value) => { this.customerAddressArr[index].street_name = value; this.recomputeAddressError(); });
    lineItem.get('interior_number').valueChanges.subscribe((value) => { this.customerAddressArr[index].interior_number = value; this.recomputeAddressError(); });
    lineItem.get('house_number').valueChanges.subscribe((value) => { this.customerAddressArr[index].house_number = value; this.recomputeAddressError(); });
    this.lineItems.push(lineItem);
  }

  private recomputeAddressError() {
    const matchedAddress = this.customerAddressArr?.find(addr =>
      !!(
        addr?.city?.trim() ||
        addr?.country?.trim() ||
        addr?.house_number?.trim() ||
        addr?.interior_number?.trim() ||
        addr?.postal_code?.trim() ||
        addr?.state?.trim() ||
        addr?.street_name?.trim()
      )
    );
    this.showAddressError = !matchedAddress;
  }

  changeAddField(event, type, ix) {
    if (type == 'addTitle') {
        this.customerAddressArr[ix].title = event
    }

}

addAdditionalAddress(event) {
  // let fieldLength = this.field_address?.field_length || 0;
  // const currentLength = this.customerAddressArr?.length ==0?1: this.customerAddressArr?.length|| 0;
  // if (currentLength >= fieldLength) {
  //   this.snackBar.open(`You cannot add more than ${fieldLength} Address`, 'Close', {
  //     duration: 2000,
  //     panelClass: ['custom-snackbar']
  //   });
  //   return;
  // }
  this.customerAddressArr.forEach((address, index) => {
    this.customerAddressArr[index].additional_add_show = false;
  });
  this.customerAddressArr.push(new emptyAddress());
  this.addLineItem(this.customerAddressArr.length - 1);

}

async removeAddress(id: any) {
  const dialogData = new ModalModel(this.translateService.instant('PROFILE.CONFIRMDELETE'));
  const dialogRef = this.dialog.open(ModalComponent, {
      width: "450px",
      data: dialogData,
      panelClass: 'my-dialog-panel',
  });
  dialogRef.afterClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
          this.customerAddressArr.splice(id, 1);
          this.lineItems.removeAt(id)

      }
  });
}

onAddressInput(event: any, field: string) {
  if (Array.isArray(this.customerAddressArr)) {
    for (let i = 0; i < this.customerAddressArr.length; i++) {
      const address = this.customerAddressArr[i];
      if (address && (!address.title || address.title.trim() === '')) {
        address.title = this.selectedAddress ? this.selectedAddress : 'Billing Address';
      }
    }
  }

  this.recomputeAddressError();
}

}

